/// <reference path="../../../../../typings/index.d.ts" />

module Meevo.Plugins.MeevoMessenger {
    export class MeevoMessengerAutoScrollTo implements angular.IDirective {
        restrict = 'A';
        scope = {
            textelAutoScrollTo: "="
        };
        link = (scope: any, element: angular.IAugmentedJQuery) => {
            scope.$watchCollection(() => scope.textelAutoScrollTo, (newValue) => {
                if (newValue) {
                    this.$timeout(() => {
                        element.animate({ scrollTop: element[0].scrollHeight }, 'fast');
                    }, 0);
                }
            });
        };

        constructor(
            protected $timeout: ng.ITimeoutService
        ) { }

        static factory(): angular.IDirectiveFactory {
            let directive = ($timeout) => new MeevoMessengerAutoScrollTo($timeout);
            directive.$inject = [
                '$timeout'
            ];

            return directive;
        }
    }

    angular.module('meevo.plugins.meevoMessenger')
        .directive('meevoMessengerAutoScrollTo', MeevoMessengerAutoScrollTo.factory());
}
